import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import SpotltmClient from 'Services/Apis/Spot/ltmApiService';

export const cardBrandAsync = createAsyncThunk(
  'cardBrand/fetchCardBrand',
  async (arg, { getState }) => {
    const { user } = getState().oidc;

    const customHeaders = {
      Authorization: `Bearer ${user.access_token}`,
      campaignId: user.profile['custom:campaign_id'],
      catalogId: user.profile['custom:catalog_id'],
      participantId: user.profile['custom:participant_id'],
      username: user.profile.username || user.profile['custom:login'],
      'x-tenant': user.profile['custom:campaign_id'],
      'x-cachekey': user.profile['custom:catalog_id'],
      'Ocp-Apim-Subscription-Key':
        process.env.REACT_APP_CLOUD_LOYALTY_SUBSCRIPTION,
    };
    try {
      const response = await SpotltmClient.get(
        'cloudloyalty/v1/configurations/cardBrands',
        {
          headers: customHeaders,
        }
      );
      const data = response.data;
      return data;
    } catch (error) {
      throw error;
    }
  }
);

const initialState = {
  loadingCardBrands: false,
  cardBrands: [],
};

const cardBrandSlice = createSlice({
  name: 'cardBrandSlice',
  initialState,
  reducers: {
    resetCardBrands: (state) => {
      state.cardBrands = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(cardBrandAsync.pending, (state) => {
        state.loadingCardBrands = true;
      })
      .addCase(cardBrandAsync.fulfilled, (state, action) => {
        state.loadingCardBrands = false;
        state.cardBrands = action.payload;
      });
  },
});
export const { resetCardBrands } = cardBrandSlice.actions;
export default cardBrandSlice.reducer;
